import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { OrderPropertiesModel } from "@rightstore/Model/OrderProperties.model";

export default function useOrderProperties(order: OrderModel): OrderPropertiesModel {
    return {
        placedByUserName: order.properties.placedByUserName
    }
}
